import { render } from "./DropdownOptions.vue?vue&type=template&id=1dd6d4a8"
import script from "./DropdownOptions.vue?vue&type=script&lang=ts"
export * from "./DropdownOptions.vue?vue&type=script&lang=ts"
script.render = render

export default script